/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CompanyContainer,
  HeaderTitle,
  StyledContainer,
  TableCell,
  TableWrapper,
  IconButton,
  LoaderWrapper,
} from '../../../services/settings/appStyle/global.style';

import { Table, IconButton as IconButtonWithText, Loader } from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import { useCompany } from '../../../hooks/CompanyContext';
import GeofenceService from '../../../services/bioplus-services/geofence';
import { DownloadIcon, EditIcon, EyeIcon } from '../../../Components/icons';
import moment from 'moment';
import EditGeofenceModal from './modals/editGeofenceModal';
import { ViewGeofenceDetailsModal } from './modals';
import { IntlMessages } from '../../../helper/langHelper';
import { exportExcelFile } from '../../../helper/exportExcelHelper';

export function extractData(dataArray) {
  if (dataArray) {
    const extractedData = dataArray?.items?.map((item) => {
      return {
        CompanyName: item.companyName,
        PremiseName: item.premiseName,
        GeofenceName: item.name,
        OccupiedRegistered: item.registeredOccupants,
        OccupiedUnregistered: item.unregisteredOccupants,
        Creator: item.createdBy,
      };
    });
    return { bioplusUsers: extractedData };
  }
}

const CorporateGeofence = () => {
  const userContext = useUserContext();
  const companyContext = useCompany();
  const companyFilter = companyContext?.company?._id;
  const parentId = userContext?.company?.companyId?.id;
  const userRole = userContext.company;

  const [editGeofence, setEditGeofence] = useState();
  const [viewGeofence, setViewGeofence] = useState();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [name, setName] = useState();

  const geofenceQuery = useQuery(['geofences', parentId, companyFilter, name, page, pageSize], () =>
    GeofenceService.listByParent(
      parentId,
      { companyId: companyFilter, name, occupants: true },
      page,
      pageSize
    )
  );

  const geofenceTableData = geofenceQuery?.data?.items ?? [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.company" />,
        accessor: 'companyName',
        Cell: (cellData) => <TableCell>{cellData.value}</TableCell>,
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.premise" />,
        accessor: 'premiseName',
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.geofence" />,
        accessor: 'name',
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.occupied.reg" />,
        accessor: 'registeredOccupants',
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.occupied.unReg" />,
        accessor: 'unregisteredOccupants',
        width: '15%',
      },
      {
        Header: <IntlMessages id="table.col.creator" />,
        accessor: 'createdBy',
      },
      {
        Header: <IntlMessages id="table.col.actions" />,
        accessor: 'actions',
        isAction: true,
        width: '15%',
      },
    ],
    []
  );

  const actionList = [
    (data) => (
      <IconButton onClick={() => setEditGeofence(data)}>
        <EditIcon style={{ width: '18px', height: '18px' }} />
      </IconButton>
    ),
    (data) => (
      <IconButton onClick={() => setViewGeofence(data)}>
        <EyeIcon style={{ width: '22px', height: '22px' }} />
      </IconButton>
    ),
  ];

  const excelFormatData = extractData(geofenceQuery.data);
  const fileName = `Geofences-${userRole?.companyName}-${moment().format(
    'DD-MM-YYYY-hh.mm A'
  )}.xlsx`;
  const columnConfig = [
    { header: 'Entity Name', key: 'CompanyName', width: 30 },
    { header: 'Property Name', key: 'PremiseName', width: 30 },
    { header: 'Geofence Name', key: 'GeofenceName', width: 30 },
    { header: 'Occupied Registered', key: 'OccupiedRegistered', width: 30 },
    { header: 'Occupied Unregistered', key: 'OccupiedUnregistered', width: 30 },
    { header: 'Creator', key: 'Creator', width: 30 },
  ];

  if (geofenceQuery.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.geofences" />
        </HeaderTitle>
        {excelFormatData && (
          <IconButtonWithText
            text={<IntlMessages id="button.text.downloadExcel" />}
            icon={<DownloadIcon />}
            onClick={() => exportExcelFile(excelFormatData, fileName, columnConfig)}
          />
        )}
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={geofenceTableData}
          columns={userColumns}
          hasFooter={true}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={geofenceQuery?.data?.length || 0}
          actions={actionList}
        />
      </TableWrapper>
      {editGeofence && editGeofence !== undefined && (
        <EditGeofenceModal onClose={() => setEditGeofence(undefined)} data={editGeofence} />
      )}
      {viewGeofence && viewGeofence !== undefined && (
        <ViewGeofenceDetailsModal onClose={() => setViewGeofence(undefined)} data={viewGeofence} />
      )}
    </StyledContainer>
  );
};

export default CorporateGeofence;
